// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KkXKc","newExpiryDate":"styles_newExpiryDate__22sXi","footer":"styles_footer__3AjDe"};